
import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const ServiciosPage = lazy(() => import('../pages/servicios/page'));
const NosotrosPage = lazy(() => import('../pages/nosotros/page'));
const ContactoPage = lazy(() => import('../pages/contacto/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />
  },
  {
    path: '/servicios',
    element: <ServiciosPage />
  },
  {
    path: '/nosotros',
    element: <NosotrosPage />
  },
  {
    path: '/contacto',
    element: <ContactoPage />
  },
  {
    path: '*',
    element: <NotFoundPage />
  }
];

export default routes;
